import vjf from 'mobx-react-form/lib/validators/VJF';
import validator from 'validator';

const validatorWithPackage = {
  ...validator,
  package: validator, // Add the package property
};

export const plugins = {
  vjf: vjf(validatorWithPackage),
};
